import CorporateConnectCard from './CorporateConnectCard';

export default CorporateConnectCard;



// WEBPACK FOOTER //
// ./src/components/CorporateConnectCard/index.js